import { render, staticRenderFns } from "./tariffs.vue?vue&type=template&id=0fc72502&scoped=true&"
import script from "./tariffs.vue?vue&type=script&lang=js&"
export * from "./tariffs.vue?vue&type=script&lang=js&"
import style0 from "./tariffs.vue?vue&type=style&index=0&id=0fc72502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc72502",
  null
  
)

export default component.exports